// Blog constants + client helpers. Post content is now stored in MongoDB and
// served via /api/blog/posts — this file only defines category metadata and
// fetch helpers used by the blog pages and admin blog tab.

import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const BLOG_CATEGORIES = [
  { slug: "moving-tips", name: "Moving Tips" },
  { slug: "cleaning-guides", name: "Cleaning Guides" },
  { slug: "local-indiana", name: "Local Indiana" },
  { slug: "business", name: "For Businesses" },
];

export const getBlogPostPath = (slug) => `/${slug}`;

export const getCategoryName = (slug) =>
  BLOG_CATEGORIES.find((c) => c.slug === slug)?.name || "General";

// Public fetchers
export const fetchBlogPosts = async () => {
  const res = await axios.get(`${API}/blog/posts`);
  return res.data;
};

export const fetchBlogPost = async (slug) => {
  const res = await axios.get(`${API}/blog/posts/${slug}`);
  return res.data;
};

// Admin fetchers (require Bearer token)
export const fetchAdminBlogPosts = async (token) => {
  const res = await axios.get(`${API}/admin/blog/posts`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const createBlogPost = async (token, payload) => {
  const res = await axios.post(`${API}/admin/blog/posts`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const updateBlogPost = async (token, id, payload) => {
  const res = await axios.put(`${API}/admin/blog/posts/${id}`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const deleteBlogPost = async (token, id) => {
  await axios.delete(`${API}/admin/blog/posts/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
